import React, { useState } from "react";

import clsx from "clsx";

import { useCustomerBreakdownConfigs } from "@components/data/customer-breakdown-configs";
import { LoadingSlide } from "@components/title-slide-view";

import { Main } from "./main";
import { Sidebar } from "./sidebar";

export const CustomerLtvView = () => {
  const { value: breakdownConfigs } = useCustomerBreakdownConfigs();

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  if (!breakdownConfigs) {
    return <LoadingSlide />;
  }

  return (
    <div
      className={clsx("grid h-full", {
        "grid-cols-[330px_auto]": !isSidebarCollapsed,
        "grid-cols-[40px_auto]": isSidebarCollapsed,
      })}
    >
      <div className="border-r border-gray-2">
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />
      </div>
      <div>
        <Main />
      </div>
    </div>
  );
};
